import { DateTime } from 'luxon';

import AdvancedReportSchedule from '@/common/models/reports/AdvancedReportSchedule';
import API from '@/org-app/api';
import {
  createDeleteAction,
  createGetAllAction,
  createGetOneAction,
  createPostAction,
  createPutAction,
} from '@/utils/ActionsUtils';

import * as types from './mutation-types';

export default {
  createNewAdvancedReportSchedule(
    { commit },
    advancedReportSchedule = AdvancedReportSchedule.fromObject({
      id: -1,
      executionTimezone: DateTime.local().zone.name,
    }),
  ) {
    commit(types.CREATE_ADVANCEDREPORTSCHEDULE, advancedReportSchedule);
    return advancedReportSchedule;
  },
  getAdvancedReportSchedules: createGetAllAction(
    API.instance.getAdvancedReportSchedules,
    types.UPDATE_ADVANCEDREPORTSCHEDULES_LIST,
    'messages.failedToGetReportSchedules',
    true,
  ),
  getAdvancedReportSchedule: createGetOneAction(
    API.instance.getAdvancedReportSchedule,
    types.GET_ADVANCEDREPORTSCHEDULE,
    'messages.failedToGetReportSchedule',
  ),
  createAdvancedReportSchedules: createPostAction(
    API.instance.postAdvancedReportSchedules,
    types.SAVE_ADVANCEDREPORTSCHEDULE,
    'messages.failedToCreateReportSchedule',
  ),
  updateAdvancedReportSchedule: createPutAction(
    API.instance.putAdvancedReportSchedule,
    types.SAVE_ADVANCEDREPORTSCHEDULE,
    'messages.failedToSaveReportExecution',
  ),
  deleteAdvancedReportSchedule: createDeleteAction(
    API.instance.deleteAdvancedReportSchedule,
    types.DELETE_ADVANCEDREPORTSCHEDULE,
    'messages.failedToDeleteReportSchedule',
  ),
};
